const consentWording = "I consent to providing my personal information and I consent to ongoing treatment.";

export {consentWording}